import dayjs from 'dayjs';

import { trackingNotificationType } from '../../constants';

export const transferNotificationData = (
  investmentStocks = [],
  selectedInvestmentStock = ''
) => {
  return investmentStocks.map((i) => {
    let items = [];
    if (i?.otherInfo) {
      const parseOtherInfo = JSON.parse(i.otherInfo);
      items = parseOtherInfo?.length
        ? parseOtherInfo
            ?.filter((news) => {
              const tags = news.machungkhoan
                ? JSON.parse(news.machungkhoan)
                : [];
              const exist = tags.filter(
                (tag) => tag === selectedInvestmentStock
              );
              return exist?.length > 0;
            })
            ?.map((news) => ({
              ...news,
              publishedAt: dayjs(new Date(Number(news.publishedAt))).format(
                'DD/MM/YYYY h:mm A'
              ),
            }))
        : [];
    }
    return {
      id: i.id,
      message: i.message,
      status: i.status,
      type: i.type,
      timeSend: dayjs(new Date(Number(i.timeSend))).format('DD/MM/YYYY h:mm A'),
      items,
      otherInfo: i.otherInfo ? JSON.parse(i.otherInfo) : '',
    };
  });
};

const mergeTwoArray = (id, arr1 = [], arr2 = []) => {
  if (!arr1[0]?.[id]) {
    return [...arr1, ...arr2];
  }
  const merged = arr1;
  for (let i = 0; i < arr2.length; i++) {
    const item = arr1.find((itmInner) => itmInner?.[id] === arr2[i]?.[id]);
    if (!item) {
      merged.push({ ...arr2[i] });
    }
  }
  return merged;
};

export const transferAndGroupNotificationData = (
  investmentStocks = [],
  listStockShow = []
) => {
  const notifications = [];
  for (const notification of investmentStocks) {
    if (
      (notification.type === trackingNotificationType.GENERAL &&
        notification.tags.indexOf('general') == -1) ||
      (notification.type === trackingNotificationType.GENERAL_FOLLOW &&
        notification.tags.indexOf('general') == -1)
    ) {
      // Noop
    } else {
      const timeSend = dayjs(new Date(Number(notification.timeSend))).format(
        'DD/MM/YYYY h:mm A'
      );
      const item = notifications.find(
        (n) => n.type === notification.type && n.timeSend === timeSend
      );
      let items = [];
      let otherInfo = [];
      if (notification?.otherInfo) {
        const parseOtherInfo = JSON.parse(notification.otherInfo);
        items = parseOtherInfo?.length
          ? parseOtherInfo
              .filter((news) => {
                const tags = news.machungkhoan
                  ? JSON.parse(news.machungkhoan)
                  : [];
                const exist = listStockShow.filter((value) =>
                  tags.some((tag) => tag === value)
                );
                return exist?.length > 0;
              })
              ?.map((news) => ({
                ...news,
                publishedAt: dayjs(new Date(Number(news.publishedAt))).format(
                  'DD/MM/YYYY h:mm A'
                ),
              }))
          : [];

        otherInfo = !Array.isArray(parseOtherInfo?.financialAgo)
          ? [parseOtherInfo]
          : parseOtherInfo;
        if (parseOtherInfo?.financialAgo) {
          items = [notification.message];
        }
      }
      if (notification.type !== trackingNotificationType.newsUpdate) {
        items = [notification.message];
      }
      if (!item) {
        notifications.push({
          id: notification.id,
          message: notification.message,
          status: notification.status,
          type: notification.type,
          tags: notification.tags,
          timeSend,
          items,
          otherInfo,
          info: notification.otherInfo,
        });
      } else {
        const index = notifications.findIndex(
          (n) => n.type === notification.type && n.timeSend === timeSend
        );
        notifications[index] = {
          id: notification.id,
          message: `${notification.message}${item.message}`,
          status: notification.status,
          type: notification.type,
          tags: notification.tags,
          info: notification.otherInfo,
          timeSend,
          items: mergeTwoArray('aliasCode', item.items, items),
          otherInfo: [...item.otherInfo, ...otherInfo],
        };
      }
    }
  }
  return notifications;
};

export const getTotalNotificationByFollowCategory = (
  followStocks,
  selectedId,
  unreadNotifications
) => {
  let total = 0;
  const followStock = followStocks.find((f) => f.id === selectedId);
  followStock?.items?.forEach((stock) => {
    const item = unreadNotifications.find(
      (u) => u.stock === stock.machungkhoan
    );
    total += Number(item?.total) || 0;
  });
  return total > 0 ? `(${total})` : '';
};
